// extracted by mini-css-extract-plugin
export default {"app":"App_app__zr1wm","components":"App_components__s4xQC"};